// React
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";

// @mui material components
import {
  Card,
  CircularProgress,
  Fade,
  Grid,
  Icon,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Tooltip,
} from "@mui/material";

import { gql, useMutation, useQuery } from "@apollo/client";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { MessageManager } from "context";
// import { ConfirmarContext } from "context/ConfirmarContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "95%",
  width: { xs: "90%", sm: "60%", xxl: "50%" },
  overflowY: "auto",
  p: 3,
};

const mesaInicial = {
  numero: "",
  idArea: null,
};
export default function ModalMesa({ open, handleClose, refetch, selectedMesa, onAreaSaved }) {
  const [mesa, setMesa] = useState(mesaInicial);

  const handleChangeMesa = (e) => {
    setMesa({
      ...mesa,
      [e.target.name]: e.target.value,
    });
  };
  const { handleSnackbar } = useContext(MessageManager);
  // const { confirmar } = useContext(ConfirmarContext);

  const { data: dataAreas } = useQuery(
    gql`
      query areas {
        areas {
          id
          nombre
        }
      }
    `,
    {
      fetchPolicy: "network-only",
    }
  );

  const [saveMesa, { loading: loadingSave }] = useMutation(
    gql`
      mutation saveMesa($input: MesaInput!) {
        saveMesa(input: $input) {
          id
        }
      }
    `
  );

  const handleSave = () => {
    saveMesa({
      variables: {
        input: {
          id: selectedMesa ? selectedMesa.id : null,
          numero: mesa.numero,
          idArea: mesa.idArea,
        },
      },
    })
      .then(() => {
        onAreaSaved?.(mesa.idArea);
        handleSnackbar("Mesa guardada correctamente", "success");
        refetch();
        handleClose();
      })
      .catch((error) => {
        const errorMessage = error?.graphQLErrors?.[0]?.message || "Error al guardar";
        handleSnackbar(errorMessage, "error");
      });
  };

  useEffect(() => {
    if (selectedMesa) {
      setMesa({
        ...selectedMesa,
        idArea: selectedMesa.area?.id || null,
      });
    } else {
      setMesa(mesaInicial);
    }
  }, [selectedMesa, open]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox display="flex" justifyContent="space-between">
              <SoftBox>
                <SoftTypography variant="h6">Mesa</SoftTypography>
              </SoftBox>
              <SoftBox display="flex" justifyContent="space-between">
                <SoftBox>
                  <Tooltip title="Cerrar" placement="top">
                    <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                      close
                    </Icon>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
            </SoftBox>
            <SoftBox py={2}>
              <Grid container spacing={1}>
                <Grid item xs={6} sm={12}>
                  <InputLabel htmlFor="numero">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Número / Nombre
                      <SoftTypography variant="caption" fontWeight="bold" color="primary">
                        &nbsp;*
                      </SoftTypography>
                    </SoftTypography>
                  </InputLabel>
                  <SoftInput
                    placeholder="Ingrese el número o nombre de mesa"
                    type="text"
                    name="numero"
                    value={mesa.numero}
                    onChange={handleChangeMesa}
                  />
                </Grid>
                <Grid item xs={6} sm={12}>
                  <InputLabel htmlFor="area">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Area
                    </SoftTypography>
                  </InputLabel>
                  <Select
                    placeholder="Seleccione una categoría"
                    value={mesa.idArea}
                    onChange={handleChangeMesa}
                    name="idArea"
                    disabled={dataAreas?.areas?.length === 0}
                  >
                    {dataAreas?.areas?.map((area) => (
                      <MenuItem key={area.id} value={area.id}>
                        {area.nombre}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Grid>
            </SoftBox>
            <SoftBox
              display={{
                xs: "flex-row",
                sm: "flex",
              }}
              justifyContent="flex-end"
              alignItems="center"
            >
              <SoftBox
                display={{
                  xs: "flex-row",
                  sm: "flex",
                }}
                justifyContent="end"
                alignItems="center"
              >
                <SoftBox
                  mr={{
                    xs: 0,
                    sm: 2,
                  }}
                  mt={{
                    xs: 2,
                    sm: 0,
                  }}
                >
                  <SoftButton
                    color="primary"
                    circular
                    onClick={handleClose}
                    fullWidth={{
                      xs: true,
                      sm: false,
                    }}
                    disabled={loadingSave}
                  >
                    <Icon sx={{ fontWeight: "light" }}>cancel</Icon>
                    &nbsp;Cancelar
                  </SoftButton>
                </SoftBox>
                <SoftBox
                  mt={{
                    xs: 2,
                    sm: 0,
                  }}
                >
                  <SoftButton
                    color="uproGreen"
                    circular
                    fullWidth={{
                      xs: true,
                      sm: false,
                    }}
                    onClick={handleSave}
                    disabled={loadingSave || !mesa.numero}
                  >
                    {false ? (
                      <CircularProgress size={15} color="inherit" />
                    ) : (
                      <Icon sx={{ fontWeight: "light" }}>save</Icon>
                    )}
                    &nbsp;Guardar
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalMesa.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  refetch: PropTypes.func,
  selectedMesa: PropTypes.object,
  onAreaSaved: PropTypes.func,
};
